import TextModel from "src/Models/Form/TextModel";

export function isTextModel(field: {[key: string]: any}): field is TextModel {
  return (field as TextModel).text !== undefined;
}
